<template>
    <card-wrapper :title="Lang.get('employerdashboard::pages/news/index.title')"
                 :subtitle="Lang.get('employerdashboard::pages/news/index.subtitle')">
        <card-layout :size="'large'" card_padding="px-0 pb-4">
            <ul class="nav nav-tabs px-3" id="employeeTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active font-poppins font-size-14 color-blue" id="all-tab"
                       data-toggle="tab" href="#all" role="tab" aria-controls="home" aria-selected="true">
                        {{ Lang.get('employerdashboard::pages/news/index.tabs.all.title') }}
                    </a>
                </li>
            </ul>

            <div class="tab-content" id="notificationTabContent">
                <div class="tab-pane fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
                    <div @click="openNewsItem(route('nl.employerdashboard.news.item', {company_as_uuid: $page.props.auth.user.selected_company.uuid}))" class="card border-0">
                        <div class="card-header px-4 py-3 bg-white highlight-on-hover">
                            <span class="font-poppins font-weight-light font-size-18 color-blue">
                                <div style="float:right">
                                    <i class="fas fa-chevron-right"></i>
                                </div>
                                 <div v-if="$page.props.isDemoMode">
                                     Welkom op je demo dashboard! 😃
                                 </div>
                                <div v-else>
                                    Welkom op je (nieuwe) dashboard! 😃
                                </div>
                             </span>
                        </div>
                    </div>
                </div>
            </div>
        </card-layout>
    </card-wrapper>
</template>

<script>
    import CardWrapper from '@/Shared/CardWrapper';
    import CardLayout from "@/Shared/CardLayout";
    import Pagination from '@/Shared/Pagination';
    import SearchFilter from '@/Shared/Search';
    export default {
        metaInfo: { title: Lang.get('employerdashboard::pages/news/index.title') },
        components: {
            CardWrapper,
            CardLayout,
            Pagination,
            SearchFilter,
        },
        props: {
            company: Object,
            items: Array,
            user: Object
        },
        methods: {
            openNewsItem(slug) {
                window.location.href = slug;
            }
        }
    }
</script>
